import script from "./VCheckbox.vue?vue&type=script&setup=true&lang=ts"
export * from "./VCheckbox.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__